// @libraries
import * as Yup from 'yup'

const firstName = Yup.string().required('First Name is required!')

const lastName = Yup.string().required('Last Name is required!')

export const validationSchema = Yup.object().shape({
  firstName,
  lastName,
})
